<template lang="pug">
div.logoslider
	div.swiper-container
		div.swiper-wrapper
			div.swiper-slide(v-for="logo in content.logos")
				figure
					div
						img(v-bind:src="logo.img")
	div.swiper-pagination
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'

export default {
	name: 'Logoslider',
	props: ['content'],
	data() {
		return {
			slider: null,
			settings: {
				speed: 600,
				loop: false,
				autoplay: {
					delay: 2000,
			  },
				slidesPerView: 3,
				spaceBetween: 0,
				autoHeight: true,
				pagination: {
					clickable: true
				},
				navigation: {}
			}
		}
	},
	methods: {
		initSlider() {
			if(this.slider == null) {
				setTimeout(()=>{
					this.settings.pagination.el = '.logoslider .swiper-pagination';
					this.slider = new Swiper('.logoslider .swiper-container', this.settings);
				}, 50);
			}
		},
		destroySlider() {
			if(this.slider != null) {
				this.slider.destroy(true);
				this.slider = null;
			}
		},
		toggleSliderOnResize() {
			const breakpoint = window.matchMedia("(min-width: 480px)");

			if (breakpoint.matches) {
				this.destroySlider();
			} else {
				this.initSlider();
			}
		}
  },
	mounted() {
		window.addEventListener('resize', () => this.toggleSliderOnResize() );
		this.toggleSliderOnResize();
	}
}
</script>



// WEBPACK FOOTER //
// src/components/features/Logoslider/index.vue